import React from "react";
import cl from "classnames";

export default function Test({ tab }) {
  return (
    <div
      className={cl("lesson_tab p-3 w-100 h-100", {
        active: tab === "test",
      })}
      id="tests"
      role="tabpanel"
      aria-labelledby="tests-tab"
    >
      <div>
        <p className="text-center lead">
          Ваше упражнение проверяется по этим тестам
        </p>
        <div>
          <pre>
            <code className="hljs clojure language-clojure">
              (
              <span className="hljs-name">
                <span className="hljs-built_in">ns</span>
              </span>{" "}
              lambda-call-test (<span className="hljs-symbol">:require</span>{" "}
              [test-helper <span className="hljs-symbol">:refer</span>{" "}
              [assert-output]])) (
              <span className="hljs-name">assert-output</span>{" "}
              <span className="hljs-string">"3"</span>)
            </code>
          </pre>
        </div>
      </div>
    </div>
  );
}
